import { useState, useContext, useEffect, useCallback } from "react";
import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import StatusDot from "../../../../../Components/status_dot";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import SearchByCategory from "../../../../../Components/category_based_search";
import FilterListIcon from "@material-ui/icons/FilterList";
import RefreshIcon from "@material-ui/icons/Refresh";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import { MIContext } from "./MIContext";
import MIStyles from "./MIStyles";
import Columns from "./Columns";
import useDebounce from "../../../../../Components/debounce";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import ColumnsSelector from "./ColumnsSelector";
import ExportSelector from "../ExportSelector";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const dropdownOptions = [
  { label: "Coachee", value: "coachee" },
  { label: "Program type", value: "programme_type" },
  { label: "Location", value: "location" },
];
const ITEM_HEIGHT = 48;

const options1 = ["View summary", "View details"];

let l = 1;

const alertLegends = [
  { variant: "positive", text: "On track" },
  { variant: "warning", text: "On hold" },
  { variant: "negative", text: "Needs immediate attention" },
];

const MITable = (props) => {
  const classes = MIStyles();
  // Columns
  const [finalColumn, setFinalColumn] = useState(Columns());

  const dispatch = useDispatch();
  const globaluserData = useSelector((state) => state.commonReducer);
  const orgID = globaluserData.organisation_id;

  const {
    anchorPopover,
    currentSelection,
    setCurrentSelection,
    viewAction,
    setViewAction,
    anchorEl,
    setAnchorEl,
    setFilterModal,
    setAction,
    tableSearch,
    setTableSearch,
    totalCount,
    assignmentData,
    tableLoader,
    dateFilter,
    statisticsFilter,
    serviceType,
    service,
    organisationID,
    page,
    setPage,
    pageSize,
    setPageSize,
  } = useContext(MIContext);

  // Search
  const [searchText, setSearchText] = useState(tableSearch.searchText || "");
  const debouncedSearchText = useDebounce(searchText, 700);

  let role = globaluserData.role;

  const ShowColumnsSelector = useCallback(() => {
    return (
      <ColumnsSelector
        setColumns={setFinalColumn}
        InitialColumns={finalColumn}
        totalColumns={Columns()}
        isRefetchingMiTable={props.isRefetchingMiTable}
      />
    );
  }, [props.isRefetchingMiTable]);

  useEffect(() => {
    setTableSearch((prev) => {
      return { ...prev, searchText: debouncedSearchText };
    });
  }, [debouncedSearchText]);

  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch({
      type: "setFilterValues",
      payload: {
        tableSearch,
        dateFilter,
        statisticsFilter,
        serviceType,
        service,
        organisationID,
        selectedColumns: finalColumn
          .filter((el) => !el.hidden || el.field === "id")
          .map((el) => el.field),
      },
    });
  }, [
    tableSearch,
    dateFilter,
    statisticsFilter,
    serviceType,
    service,
    organisationID,
    finalColumn,
  ]);

  const i = 2;
  let history = useHistory();

  const filteredItems = options1
    .slice(0, i)
    .concat(options1.slice(i + 1, options1.length));

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentSelection({});
  };

  const handleOption = (option) => {
    if (option === "View summary") {
      setAction("view_summary");
      history.push({
        pathname: "assignmentsummary",
        state: { currentAssignment: currentSelection },
      });
    }
    if (option === "View details") {
      history.push({
        pathname: "assignmentoverview",
        state: { currentAssignment: currentSelection },
      });
    } else if (option === "Send on Cal, or Repair") {
      setAction("on_repair");
    } else if (option === "View Cert") {
    } else {
      setAction(option);
    }
    dispatch({
      type: "setFilterValues",
      payload: {
        tableSearch,
        dateFilter,
        statisticsFilter,
        serviceType,
        service,
        organisationID,
        selectedColumns: finalColumn
          .filter((el) => !el.hidden || el.field === "id")
          .map((el) => el.field),
      },
    });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className={classes.miTable}>
      <MaterialTable
        isLoading={tableLoader}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant='subtitle1'
              color='secondary'
              style={{ fontWeight: "bold" }}
            >
              Assignments
            </Typography>
            <div className={classes.searchCategory}>
              <SearchByCategory
                options={dropdownOptions}
                selectedOption={tableSearch.searchCategory || "all"}
                defaultOption={"All"}
                setSelectedOption={(event) => {
                  setTableSearch((prev) => {
                    return { ...prev, searchCategory: event };
                  });
                }}
                style={{ fontSize: "16px" }}
                searchText={searchText}
                handleSearchText={(event) => {
                  setSearchText(event);
                }}
              />
            </div>
          </div>
        }
        options={{
          actionsColumnIndex: -1,
          searchFieldAlignment: "right",
          columnsButton: false,
          exportButton: false,
          search: false,
          pageSize: pageSize,
          total: totalCount,
          emptyRowsWhenPaging: false,
          sorting: true,
          pageSizeOptions: [100,150,250,400,500],
          headerStyle: {
            position: "sticky",
            top: "0",
          },
          maxBodyHeight: "600px",
          actionsCellStyle: {
            position: "sticky",
            right: 0,
            zIndex: 1,
            background: "white",
          },
        }}
        localization={{
          header: {
            actions: (
              <span
                style={{
                  textAlign: "left",
                  background: "white",
                  paddingLeft: "24px",
                  zIndex: 20,
                }}
              >
                Assignment view
              </span>
            ),
          },
        }}
        columns={finalColumn}
        data={assignmentData}
        totalCount={totalCount}
        page={page}
        onChangePage={(currentPage) => {
          setPage(currentPage);
        }}
        onChangeRowsPerPage={(currentPageSize) => {
          setPageSize(currentPageSize);
          // if (!(currentPageSize % totalCount >= currentPageSize)) {
            setPage(0);
          // }
        }}
        actions={[
          {
            icon: () => (
              <div id={`div`} style={{ width: "90px" }}>
                <IconButton
                  className={classes.textSecondary}
                  aria-label='more'
                  aria-haspopup='true'
                  disableRipple
                >
                  <MoreVertIcon />
                </IconButton>
              </div>
            ),
            onClick: (...args) => {
              console.log(args, "args", args[0]?.target);
              setCurrentSelection(args[1]);
              handleClick(args[0]);
            },
          },
          {
            icon: ShowColumnsSelector,
            isFreeAction: true,
          },
          {
            icon: () => {
              const params = {
                page: page + 1,
                count_per_page: pageSize,
                search_keyword: tableSearch?.searchText,
                from_date_filter: dateFilter?.startDate,
                to_date_filter: dateFilter?.endDate,
              };

              if (serviceType && serviceType !== "all") {
                params.service = serviceType;
              }
              if (service && service !== "all") {
                params.service_type = service;
              }
              if (statisticsFilter && statisticsFilter !== "All") {
                params.main_filter = statisticsFilter;
              }
              if (
                tableSearch.searchCategory &&
                tableSearch.searchCategory.value !== "all"
              ) {
                params.filter_type = tableSearch.searchCategory.value;
              }

              if (role === "admin") {
                if (organisationID && organisationID !== "all") {
                  params.organisation_id = organisationID;
                }
              }

              if (role === "employee") {
                params.organisation_id = orgID;
              }

              const finalParams = {};

              for (let key in params) {
                if (params[key] !== undefined) {
                  if (!(params[key] === "undefined")) {
                    finalParams[key] = params[key];
                  }
                }
              }

              let url = "/assignments";
              if (!(role === "admin")) {
                url += "/list_org_assignments";
              }
              return (
                <ExportSelector
                  params={finalParams}
                  columns={finalColumn}
                  url={url}
                  downloadKey='assignments'
                  fileName='MI Assignments'
                />
              );
            },
            isFreeAction: true,
          },
          {
            icon: () => <FilterListIcon color='secondary' />,
            tooltip: <TooltipWrapper text='Filter' />,
            isFreeAction: true,
            onClick: (event, rows) => {
              setFilterModal(true);
            },
          },

          {
            icon: () =>
              props.isRefetchingMiTable ? (
                <CircularProgress color='secondary' size={20} />
              ) : (
                <RefreshIcon color='secondary' />
              ),
            tooltip: (
              <TooltipWrapper
                text={
                  props.isRefetchingMiTable
                    ? "Refetching Table Data"
                    : "Refetch Table Data"
                }
              />
            ),
            isFreeAction: true,
            onClick: () => {
              dispatch({
                type: "setFilterValues",
                payload: {
                  tableSearch,
                  dateFilter,
                  statisticsFilter,
                  serviceType,
                  service,
                  organisationID,
                  selectedColumns: finalColumn
                    .filter((el) => !el.hidden || el.field === "id")
                    .map((el) => el.field),
                },
              });
              props.refetchMITable();
            },
          },
        ]}
      />
      <div className={classes.actionButtons}>
        <div style={{ width: "50%", position: "absolute", marginTop: "8px" }}>
          <Grid container item xs={12}>
            <Grid item xs={2}>
              <StatusDot variant='positive' />
              &nbsp;&nbsp;
              <Typography variant='h2' component='span'>
                On track
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <StatusDot variant='warning' />
              &nbsp;&nbsp;
              <Typography variant='h2' component='span'>
                On hold
              </Typography>
            </Grid>
            <Grid item xs={4} lg={4} md={5}>
              <StatusDot variant='negative' />
              &nbsp;&nbsp;
              <Typography variant='h2' component='span'>
                Needs immediate attention
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>
      <Menu
        id={`long-menu`}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        {currentSelection.calibration_certificate === null
          ? filteredItems.map((option) => (
              <MenuItem
                key={option}
                className={classes.textSecondary}
                onClick={() => {
                  handleOption(option);
                }}
              >
                <Typography variant='h2'>{option}</Typography>
              </MenuItem>
            ))
          : options1.map((option) => (
              <MenuItem
                key={option}
                className={classes.textSecondary}
                onClick={() => {
                  handleOption(option);
                }}
              >
                <Typography variant='h2'>{option}</Typography>
              </MenuItem>
            ))}
      </Menu>
      {currentSelection.document === null ? (
        <Popover
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          style={{ top: "27px", left: "2%" }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          open={viewAction === "view_more"}
          anchorEl={anchorPopover}
          onClose={() => setViewAction(null)}
        >
          <div>
            <Typography
              style={{ padding: "5px 0 5px 15px" }}
              variant='subtitle1'
              color='secondary'
            >
              Credentials
            </Typography>
            <List style={{ padding: "15px" }} dense>
              <Typography variant='h2'>
                Username: {currentSelection.username} <br />
                Password: {currentSelection.password}
              </Typography>
            </List>
          </div>
        </Popover>
      ) : (
        <Popover
          anchorOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          style={{ top: "45px", left: "2px" }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          open={viewAction === "view_more"}
          anchorEl={anchorPopover}
          onClose={() => setViewAction(null)}
        >
          <Typography
            style={{ padding: "20px" }}
            variant='subtitle1'
            color='secondary'
          >
            {currentSelection.alert_message}
          </Typography>{" "}
        </Popover>
      )}
    </div>
  );
};

export default MITable;
